import { axios } from "lib/axios";
import { useNotificationStore } from "stores/notifications";
import { useMutation } from "react-query";

export const referAFriend = ({ data }) => {
  return axios.post(`/users/refer-a-friend`, data);
};

export const useReferAFriend = ({ config } = {}) => {
  const { addNotification } = useNotificationStore();
  return useMutation({
    onSuccess: (data) => {
      addNotification({
        type: "success",
        title: data.msg,
      });
    },
    ...config,
    mutationFn: referAFriend,
  });
};
